import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { ConfirmOptionsModel } from './typings/confirm.options';

@Component({
  selector   : 'confirmation-notify',
  template: require('./confirmation.notify.component.html')
})
export class ConfirmationNotifyComponent {
  @Input() options : ConfirmOptionsModel;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
